import React from 'react';
import { StarIcon } from 'lucide-react';
interface StarRatingProps {
  size?: number;
  className?: string;
}
export function StarRating({
  size = 16,
  className = ''
}: StarRatingProps) {
  return <div className={`flex items-center gap-0.5 ${className}`} role="img" aria-label="Calificación de 5 estrellas" data-id="element-263" data-mp="jogc9ezr7b5h">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} size={size} className="fill-gold text-gold" data-id="element-264" data-mp="evn9uxrrcewk" data-mpi={i} />)}
    </div>;
}